import { datesRange } from 'components/financials/financials-table-filters';
import {
  DepositSummary,
  FinancialFilters,
  OutstandingReportRow,
  OutstandingSummary,
  TransactionReport,
  TransactionSummary,
} from 'components/financials/types';
import { ReportType } from 'components/pages/financials';
import { GqlOrganization } from 'core/gql/fragments/organization';

export enum LoadingType {
  GetOrganization,
  GetDeposits,
  GetOutstandingReports,
  GetTransactions,
}

export interface FinancialsState {
  loading: Record<LoadingType, boolean>;
  // Org
  hasOrgAdminAccess: boolean;
  organization: GqlOrganization;
  // Deposits
  depositFilters: Partial<FinancialFilters>;
  deposits: TransactionReport[];
  depositSummary: DepositSummary;
  // Outstanding
  outstandingReports: OutstandingReportRow[];
  outstandingSummary: OutstandingSummary;
  outstandingFilters: Partial<FinancialFilters>;
  // Transactions
  transactions: TransactionReport[];
  transactionFilters: Partial<FinancialFilters>;
  transactionSummary: TransactionSummary;
}

// These are all ways of accessing the useFinancials
// state. Not all of these are exposed to callers.
export enum ActionType {
  SetLoading,
  SetOrgAdminAccess,
  SetOrganization,
  SetDeposits,
  UpdateFilter,
  SetOutstandingReports,
  SetOutstandingFilters,
  SetTransactions,
  SetTransactionsFilters,
}

export type SetOrgAdminAccessPayload = {
  hasOrgAdminAccess: boolean;
};

export type SetOrganizationPayload = {
  organization: GqlOrganization;
};

export type SetFiltersPayload = {
  filters: Partial<FinancialFilters>;
};

export type SetFilterPayload = {
  reportType: ReportType;
  key: string;
  value: any;
};

export type SetDepositPayload = {
  deposits: TransactionReport[];
};

export type SetOutstandingReportPayload = {
  outstandingReports: OutstandingReportRow[];
};

export type SetTransactionsPayload = {
  transactions: TransactionReport[];
};

export const defaultDepositFilters: Partial<FinancialFilters> = {
  datesRange,
  depositAccount: [],
};

export const defaultOutstandingFilters: Partial<FinancialFilters> = {
  searchTerm: '',
  datesRange,
  program: [],
  sourceType: [],
  status: [],
  registration: [],
  invoice: [],
};

export const defaultTransactionFilters: Partial<FinancialFilters> = {
  searchTerm: '',
  dateType: 'payment',
  datesRange,
  program: [],
  status: [],
  sourceType: [],
  registration: [],
  invoice: [],
  paymentType: [],
  depositAccount: [],
};
